/*
  Nordicsell TEST-TEMA - assets/ns-mobil.js
  Omgang 11 och framat (mobilen och finlir mot Boozt). Laddas efter
  ns-design.js i layout/theme.liquid. Ta bort raden dar for att stanga av.
*/
(function () {
  /*
    Omgang 11 (Boozt, mobil):
    1. Kategorisidan: underkategori-raden (sections/ns-underkategorier i
       header-gruppen) flyttas in i <main> sa att den kan sta under Filter
       och Sortera, som hos Boozt. Placeringen satts i
       assets/ns-mobil.css (al). Pa dator ar raden dold som forut.
    2. Produktsidan: prickar under bildkarusellen (en per bild), som hos
       Boozt, i stallet for miniatyrerna. Foljer temats egen karusell.
    3. Sidfoten: knappen "Till toppen" i den morka raden langst ner.
  */
  function underkatFlytta() {
    if (!document.body || !document.body.classList.contains('collection-template')) return;
    // Omgang 3e: pa dator (fran 1024 px) star raden kvar under menyn, som
    // i originaltemat. Bara mobil/surfplatta flyttar den in i <main>.
    if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) return;
    var main = document.querySelector('main');
    var uk = document.querySelector('[id$="__ns_underkategorier"]');
    if (!main || !uk || uk.parentNode === main || !main.querySelector('#ProductGridWrapper')) return;
    main.appendChild(uk);
  }
  function bildPrickar() {
    if (!document.body || !document.body.classList.contains('product-template')) return;
    var wrap = document.querySelector('main .product__media-gallery-viewer-wrap');
    var vy = wrap ? wrap.querySelector('.swiper') : null;
    var sw = vy ? vy.swiper : null;
    if (!wrap || !sw || wrap.querySelector('.ns-dots')) return;
    var antal = wrap.querySelectorAll('.product__media-list > .product__media-item').length;
    if (antal < 2) return;
    var rad = document.createElement('div');
    rad.className = 'ns-dots';
    rad.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < antal; i++) rad.appendChild(document.createElement('span'));
    wrap.appendChild(rad);
    var markera = function () {
      var a = typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex;
      [].forEach.call(rad.children, function (p, k) { p.classList.toggle('is-aktiv', k === a); });
    };
    markera();
    if (sw.on) sw.on('slideChange', markera);
  }
  function tillToppen() {
    var fot = document.querySelector('[id$="__follow_us_social"] .ns-fot');
    if (!fot || fot.querySelector('.ns-tilltoppen')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ns-tilltoppen';
    b.textContent = 'Till toppen';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    fot.appendChild(b);
  }
  // Filterknappen heter "Filter" hos Boozt (temats text ar "Filtrera").
  function filterText() {
    [].forEach.call(document.querySelectorAll('.facet-drawer-button .btn__text, .facet-drawer-button .btn__text span'), function (s) {
      [].forEach.call(s.childNodes, function (n) {
        if (n.nodeType === 3 && n.nodeValue.trim() === 'Filtrera') n.nodeValue = n.nodeValue.replace('Filtrera', 'Filter');
      });
    });
  }
  // Temat ritar om verktygsraden nar man filtrerar - byt texten igen da.
  function filterVakt() {
    var m = document.querySelector('main');
    if (m && window.MutationObserver && document.querySelector('.facet-drawer-button')) {
      new MutationObserver(filterText).observe(m, { childList: true, subtree: true });
    }
  }

  /*
    Omgang 11c (2026-09-24): ETT PRISFORMAT i hela temat.
    Butikens valutaformat ar "{{amount}} kr". Det ger "1,634.00 kr" och
    "303.20 kr" pa kort, produktsida och varukorgssida, medan varukorgs-
    ladan och favoritsidan skriver "1 634 kr" och "303,20 kr". Har skrivs
    alla priser i den synliga texten om till samma svenska format som
    ladan: mellanrum mellan tusental, komma fore oren, inga ",00".
    Bara text som slutar med "kr" och har exakt tva decimaler rors.
    Skript, stilar och formularfalt rors inte. Kontrollerat: inget av
    temats skript laser tillbaka priser ur texten (bara antalet i korgen).
    DEN RIKTIGA LOSNINGEN ar valutaformatet i Shopify (Installningar ->
    Allmant -> Butiksvaluta -> Andra formatering: {{amount_with_comma_separator}} kr).
    Da blir aven kassan ratt, och den har funktionen gor da ingenting.
  */
  var NBSP = String.fromCharCode(160);
  var PRIS_RE = /(\d{1,3}(?:,\d{3})+|\d+)\.(\d{2})(?=\s*kr)/g;
  var PRIS_HOPPA = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, CODE: 1, PRE: 1, TEMPLATE: 1 };
  function prisSv(heltal, ore) {
    var s = heltal.split(',').join('');
    var ut = '';
    for (var i = s.length - 1, c = 0; i >= 0; i--, c++) {
      if (c > 0 && c % 3 === 0) ut = NBSP + ut;
      ut = s.charAt(i) + ut;
    }
    return ore === '00' ? ut : ut + ',' + ore;
  }
  /* Omg 15: nar butikens valutaformat ar "{{amount_with_space_separator}} kr"
     ("1 634,00 kr") skrivs priserna redan pa svenska - da tas bara ",00"
     bort och mellanrummet blir ett fast mellanrum, sa att alla priser
     ser likadana ut som i ladan ("1 634 kr", "303,20 kr"). */
  var PRIS_SV_RE = /(\d{1,3}(?:[ \xa0]\d{3})*),(\d{2})(?=\s*kr)/g;
  function prisNod(n) {
    var v = n.nodeValue;
    if (!v || v.indexOf('kr') < 0) return;
    var p = n.parentNode;
    if (!p || PRIS_HOPPA[p.nodeName]) return;
    var ny = v;
    if (ny.indexOf('.') >= 0) {
      PRIS_RE.lastIndex = 0;
      if (PRIS_RE.test(ny)) {
        PRIS_RE.lastIndex = 0;
        ny = ny.replace(PRIS_RE, function (m, h, o) { return prisSv(h, o); });
      }
    }
    if (ny.indexOf(',') >= 0) {
      PRIS_SV_RE.lastIndex = 0;
      ny = ny.replace(PRIS_SV_RE, function (m, h, o) { return prisSv(h.replace(/[ \xa0]/g, ''), o); });
    }
    if (ny !== v) n.nodeValue = ny;
  }
  function prisTrad(rot) {
    if (!rot) return;
    if (rot.nodeType === 3) { prisNod(rot); return; }
    if (rot.nodeType !== 1 || PRIS_HOPPA[rot.nodeName]) return;
    var w = document.createTreeWalker(rot, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) prisNod(n);
  }
  function prisVakt() {
    if (!document.body || window.__nsPrisVakt) return;
    window.__nsPrisVakt = true;
    prisTrad(document.body);
    if (!window.MutationObserver) return;
    new MutationObserver(function (lista) {
      for (var i = 0; i < lista.length; i++) {
        var m = lista[i];
        if (m.type === 'characterData') { prisNod(m.target); continue; }
        for (var j = 0; j < m.addedNodes.length; j++) prisTrad(m.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  function kr(ore) {
    var o = Math.round(Number(ore) || 0);
    var s = String(o);
    while (s.length < 3) s = '0' + s;
    return prisSv(s.slice(0, -2), s.slice(-2)) + ' kr';
  }

  /*
    Omgang 11c: PRODUKTSIDANS INFOSPALT slutar som Boozts med tre block
    under dragspelen:
      "Upptack mer"        knappar till marke, kategori och relevanta
                           kollektioner (bara kollektioner som finns och
                           har varor - kontrolleras med products.json)
      "Besokta produkter"  tre senast besokta varor (temats egen historik
                           i webblasaren), "Visa alla" -> /pages/senast-visade
      "Favoriter"          tre favoriter (ns_wishlist), "Visa alla" ->
                           /pages/favoriter. Visas bara om det finns nagra.
    Data till "Besokta" hamtas fran sections/ns-besokta.liquid.
    Utseendet: assets/ns-mobil.css (ap).
  */
  function handleize(t) {
    var s = String(t || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g'), '');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function lsLas(nyckel) {
    try { var v = JSON.parse(localStorage.getItem(nyckel) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function pdpBlock(box, rubrik) {
    var b = el('div', 'ns-pdpx__block');
    b.appendChild(el('h2', 'ns-pdpx__h', rubrik));
    box.appendChild(b);
    return b;
  }
  function pdpKort(lista, b, allaUrl, antal) {
    var rad = el('div', 'ns-pdpx__rad');
    lista.slice(0, 3).forEach(function (p) {
      var a = el('a', 'ns-pdpx__kort');
      a.href = p.url;
      var bild = el('span', 'ns-pdpx__bild');
      if (p.img) {
        var img = document.createElement('img');
        img.src = p.img;
        img.alt = p.title || '';
        img.loading = 'lazy';
        bild.appendChild(img);
      }
      a.appendChild(bild);
      if (p.vendor) a.appendChild(el('span', 'ns-pdpx__marke', p.vendor));
      var pris = el('span', 'ns-pdpx__pris');
      var rea = p.compare && p.compare > p.price;
      var nu = el('span', rea ? 'ns-pdpx__rea' : '', kr(p.price));
      pris.appendChild(nu);
      if (rea) { pris.appendChild(document.createTextNode(' ')); pris.appendChild(el('s', '', kr(p.compare))); }
      a.appendChild(pris);
      rad.appendChild(a);
    });
    b.appendChild(rad);
    var alla = el('a', 'ns-pdpx__alla', 'Visa alla (' + antal + ')');
    alla.href = allaUrl;
    b.appendChild(alla);
  }
  function pdpUpptack(box, prod) {
    var kandidater = [];
    var v = document.querySelector('main .product__vendor a');
    if (v && v.getAttribute('href')) kandidater.push({ t: v.textContent.trim(), h: v.getAttribute('href'), klar: true });
    [].forEach.call(document.querySelectorAll('.section-breadcrumb .breadcrumbs a'), function (a) {
      var h = a.getAttribute('href') || '';
      if (h.indexOf('/collections/') === 0) kandidater.push({ t: a.textContent.trim(), h: h, klar: true });
    });
    if (prod && prod.type) kandidater.push({ t: prod.type, h: '/collections/' + handleize(prod.type) });
    if (prod && prod.tags) {
      prod.tags.forEach(function (tag) {
        if (!tag || tag.charAt(0) === '_' || tag.length < 4) return;
        kandidater.push({ t: tag.charAt(0).toUpperCase() + tag.slice(1), h: '/collections/' + handleize(tag) });
      });
    }
    var sedda = {};
    kandidater = kandidater.filter(function (k) {
      var nyckel = k.h.split('?')[0];
      if (sedda[nyckel]) return false;
      sedda[nyckel] = 1;
      return true;
    }).slice(0, 12);
    Promise.all(kandidater.map(function (k) {
      if (k.klar) return Promise.resolve(k);
      return fetch(k.h + '/products.json?limit=1', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.products && j.products.length ? k : null; })
        .catch(function () { return null; });
    })).then(function (ok) {
      ok = ok.filter(Boolean).slice(0, 8);
      if (!ok.length) return;
      var b = pdpBlock(box, 'Upptäck mer');
      var rad = el('div', 'ns-pdpx__chips');
      ok.forEach(function (k) {
        var a = el('a', 'ns-pdpx__chip', k.t);
        a.href = k.h;
        rad.appendChild(a);
      });
      b.appendChild(rad);
      box.insertBefore(b, box.firstChild);
    });
  }
  /* Hamtar kortdata (bild, marke, pris med samma Deal-pris som korten)
     for en lista med produkt-id via sections/ns-besokta.liquid. Ordningen
     foljer id-listan. */
  function hamtaPerId(ids) {
    ids = ids.slice(0, 12);
    if (!ids.length) return Promise.resolve([]);
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    return fetch('/search?section_id=ns-besokta&type=product&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var perId = {};
        [].forEach.call(tmp.querySelectorAll('[data-ns-besokta] i[data-id]'), function (i) {
          perId[i.getAttribute('data-id')] = {
            url: i.getAttribute('data-url'), img: i.getAttribute('data-img'),
            vendor: i.getAttribute('data-vendor'), title: i.getAttribute('data-title'),
            price: Number(i.getAttribute('data-price')), compare: Number(i.getAttribute('data-compare'))
          };
        });
        var lista = [];
        ids.forEach(function (id) { if (perId[String(id)]) lista.push(perId[String(id)]); });
        return lista;
      })
      .catch(function () { return []; });
  }
  function favHandles() {
    return lsLas('ns_wishlist').filter(function (h) { return typeof h === 'string' && h; });
  }
  // Favoriterna sparas som handles - hamta id forst, sedan samma kortdata.
  function hamtaFavoriter(max) {
    var handles = favHandles().slice(0, max);
    if (!handles.length) return Promise.resolve([]);
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (ps) {
      return hamtaPerId(ps.filter(Boolean).map(function (p) { return p.id; }));
    });
  }
  function pdpBesokta(box, egetId) {
    var ids = lsLas('hypertheme:recently-viewed').filter(function (id) { return String(id) !== String(egetId); });
    if (!ids.length) return;
    hamtaPerId(ids).then(function (lista) {
      if (!lista.length) return;
      var b = pdpBlock(box, 'Besökta produkter');
      b.classList.add('ns-pdpx__block--besokta');
      pdpKort(lista, b, '/pages/senast-visade', ids.length);
      var fav = box.querySelector('.ns-pdpx__block--fav');
      if (fav) box.insertBefore(b, fav);
    });
  }
  function pdpFavoriter(box) {
    var antal = favHandles().length;
    if (!antal) return;
    hamtaFavoriter(3).then(function (lista) {
      if (!lista.length) return;
      var b = pdpBlock(box, 'Favoriter');
      b.classList.add('ns-pdpx__block--fav');
      pdpKort(lista, b, '/pages/favoriter', antal);
    });
  }

  /*
    Omgang 12: "BESOKTA PRODUKTER" OCH "FAVORITER" SOM BOOZTS (dator):
    - Kategorisidan: under kategorilistan i vanster spalt, rubrik 20/500,
      sma kort tva och tva (bild, marke, pris) och "Visa alla (n)".
      Favoriter under, med en rad text om listan ar tom.
    - Startsidan: en smal fast spalt (70 px) i hogerkanten med tva flikar
      (ogat = besokta, hjartat = favoriter, med antal), korten under och
      "Visa alla" langst ner. Visas bara nar det finns besokta varor och
      nar sidans innehall inte skyms.
    Utseendet: assets/ns-finlir.css (al).
  */
  function listKort(p, cls) {
    var a = el('a', cls);
    a.href = p.url;
    var bild = el('span', cls + '-bild');
    if (p.img) {
      var img = document.createElement('img');
      img.src = p.img;
      img.alt = p.title || '';
      img.loading = 'lazy';
      bild.appendChild(img);
    }
    a.appendChild(bild);
    if (p.vendor) a.appendChild(el('span', cls + '-marke', p.vendor));
    var rea = p.compare && p.compare > p.price;
    var pris = el('span', cls + '-pris');
    pris.appendChild(el('span', rea ? 'ns-rea' : '', kr(p.price)));
    if (rea) pris.appendChild(el('s', '', kr(p.compare)));
    a.appendChild(pris);
    return a;
  }
  function sidoListor() {
    if (!document.body.classList.contains('collection-template') || !window.matchMedia('(min-width: 1024px)').matches) return;
    var mal = document.querySelector('#FacetFiltersContainer form > details[data-index$="-ns-category"] > .accordion-details__content');
    if (!mal || mal.querySelector('.ns-sl')) return;
    var box = el('div', 'ns-sl');
    mal.appendChild(box);
    var ids = lsLas('hypertheme:recently-viewed');
    var antalFav = favHandles().length;
    Promise.all([hamtaPerId(ids.slice(0, 6)), hamtaFavoriter(6)]).then(function (res) {
      var besokta = res[0], fav = res[1];
      if (besokta.length) {
        var b1 = el('div', 'ns-sl__block');
        b1.appendChild(el('h2', 'ns-sl__h', 'Besökta produkter'));
        var l1 = el('div', 'ns-sl__lista');
        besokta.forEach(function (p) { l1.appendChild(listKort(p, 'ns-sl__kort')); });
        b1.appendChild(l1);
        var a1 = el('a', 'ns-sl__alla', 'Visa alla (' + ids.length + ')');
        a1.href = '/pages/senast-visade';
        b1.appendChild(a1);
        box.appendChild(b1);
      }
      var b2 = el('div', 'ns-sl__block');
      b2.appendChild(el('h2', 'ns-sl__h', 'Favoriter'));
      if (fav.length) {
        var l2 = el('div', 'ns-sl__lista');
        fav.forEach(function (p) { l2.appendChild(listKort(p, 'ns-sl__kort')); });
        b2.appendChild(l2);
        var a2 = el('a', 'ns-sl__alla', 'Visa alla (' + antalFav + ')');
        a2.href = '/pages/favoriter';
        b2.appendChild(a2);
      } else {
        b2.appendChild(el('p', 'ns-sl__tom', 'Du har inga favoriter än. Tryck på hjärtat på en vara för att spara den här.'));
      }
      box.appendChild(b2);
    });
  }
  // Filtren ritar om formularet - lagg tillbaka listorna da.
  function sidoVakt() {
    if (!document.body.classList.contains('collection-template') || !window.MutationObserver) return;
    var m = document.querySelector('main');
    if (!m) return;
    var vantar = false;
    new MutationObserver(function () {
      if (vantar) return;
      vantar = true;
      setTimeout(function () { vantar = false; sidoListor(); }, 200);
    }).observe(m, { childList: true, subtree: true });
  }
  var OGA = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M1.5 12S5.5 5 12 5s10.5 7 10.5 7-4 7-10.5 7S1.5 12 1.5 12z"/><circle cx="12" cy="12" r="3"/></svg>';
  var HJARTA = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  function hogerRail() {
    var avd = document.body.classList.contains('collection-template') && !document.querySelector('#ProductsList');
    if ((!document.body.classList.contains('index-template') && !avd) || document.querySelector('.ns-rail') || !window.matchMedia('(min-width: 1024px)').matches) return;
    var ids = lsLas('hypertheme:recently-viewed');
    if (!ids.length) return;
    var antalFav = favHandles().length;
    var rail = el('aside', 'ns-rail');
    rail.setAttribute('aria-label', 'Mina listor');
    var flikar = el('div', 'ns-rail__flikar');
    function flik(ikon, antal, namn, aktiv) {
      var b = el('button', 'ns-rail__flik' + (aktiv ? ' is-aktiv' : '') + (antal ? '' : ' is-tom'));
      b.type = 'button';
      b.setAttribute('aria-label', namn);
      b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      b.innerHTML = ikon;
      b.appendChild(el('span', 'ns-rail__antal', String(antal)));
      if (!antal) b.disabled = true;
      flikar.appendChild(b);
      return b;
    }
    var fBes = flik(OGA, ids.length, 'Besökta produkter', true);
    var fFav = flik(HJARTA, antalFav, 'Favoriter', false);
    rail.appendChild(flikar);
    var panel = el('div', 'ns-rail__panel');
    var lista = el('div', 'ns-rail__lista');
    var alla = el('a', 'ns-rail__alla', 'Visa alla');
    panel.appendChild(lista);
    panel.appendChild(alla);
    rail.appendChild(panel);
    function visa(vilken) {
      var fav = vilken === 'fav';
      fBes.classList.toggle('is-aktiv', !fav);
      fFav.classList.toggle('is-aktiv', fav);
      fBes.setAttribute('aria-pressed', fav ? 'false' : 'true');
      fFav.setAttribute('aria-pressed', fav ? 'true' : 'false');
      alla.href = fav ? '/pages/favoriter' : '/pages/senast-visade';
      lista.textContent = '';
      (fav ? hamtaFavoriter(8) : hamtaPerId(ids.slice(0, 8))).then(function (ps) {
        lista.textContent = '';
        ps.forEach(function (p) { lista.appendChild(listKort(p, 'ns-rail__kort')); });
      });
    }
    fBes.addEventListener('click', function () { visa('bes'); });
    fFav.addEventListener('click', function () { visa('fav'); });
    document.body.appendChild(rail);
    function lage() {
      var h = document.querySelector('.shopify-section-group-header-group header, header.header, header');
      var nere = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
      rail.style.top = nere + 'px';
      var inne = document.querySelector('main .page-width');
      var hoger = inne ? inne.getBoundingClientRect().right : 0;
      var plats = document.documentElement.clientWidth - hoger >= 70;
      rail.classList.toggle('is-dold', !plats || !window.matchMedia('(min-width: 1024px)').matches);
    }
    lage();
    window.addEventListener('scroll', function () { window.requestAnimationFrame(lage); }, { passive: true });
    window.addEventListener('resize', lage);
    visa('bes');
  }
  function pdpExtra() {
    if (!document.body || !document.body.classList.contains('product-template')) return;
    var info = document.querySelector('main .product__info-container');
    if (!info || info.querySelector('.ns-pdpx')) return;
    var box = el('div', 'ns-pdpx');
    info.appendChild(box);
    fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (prod) {
        pdpUpptack(box, prod);
        // Omgang 3e: "Besokta produkter" visas inte langre pa produktsidan
        // (kundens onskan). Lagg tillbaka raden nedan for att fa tillbaka den.
        // pdpBesokta(box, prod ? prod.id : '');
        pdpFavoriter(box);
      });
  }
  /* Omgang 12: produktraderna pa startsidan som Boozts karusell pa dator -
     tio varor, fem at gangen, pilknappar 48 x 48 (CSS: ns-finlir.css aj).
     Vanster pil syns forst nar man bladdrat, hoger pil doljs vid slutet. */
  function radKarusell() {
    // Omg 13: aven avdelningssidorna (kollektionssidor utan produktrutnat).
    var avdelning = document.body.classList.contains('collection-template') && !document.querySelector('#ProductsList');
    if (!document.body.classList.contains('index-template') && !avdelning) return;
    [].forEach.call(document.querySelectorAll('.ns-collection-row .products-grid-wrap'), function (wrap) {
      if (wrap.classList.contains('ns-kar')) return;
      var spar = wrap.querySelector(':scope > .products-grid');
      if (!spar) return;
      var varor = [].slice.call(spar.children, 0, 10);
      if (varor.length <= 5) return;
      var i = 0;
      var bak = document.createElement('button');
      bak.type = 'button';
      bak.className = 'ns-kar__pil ns-kar__pil--bak';
      bak.setAttribute('aria-label', 'Bläddra åt vänster');
      bak.hidden = true;
      var fram = document.createElement('button');
      fram.type = 'button';
      fram.className = 'ns-kar__pil ns-kar__pil--fram';
      fram.setAttribute('aria-label', 'Bläddra åt höger');
      wrap.insertBefore(bak, spar);
      wrap.appendChild(fram);
      wrap.classList.add('ns-kar');
      function ga(riktning) {
        i = Math.max(0, Math.min(varor.length - 5, i + riktning * 5));
        bak.hidden = i === 0;
        fram.hidden = i >= varor.length - 5;
        window.requestAnimationFrame(function () {
          spar.scrollTo({ left: varor[i].offsetLeft - varor[0].offsetLeft, behavior: 'smooth' });
        });
      }
      bak.addEventListener('click', function () { ga(-1); });
      fram.addEventListener('click', function () { ga(1); });
      window.addEventListener('resize', function () {
        if (!window.matchMedia('(min-width: 768px)').matches) return;
        spar.scrollLeft = varor[i].offsetLeft - varor[0].offsetLeft;
      });
    });
  }
  /*
    Omgang 12: HEADERN PA BREDA SKARMAR (fran 1280 px) som Boozts: under
    loggaraden en menyrad med huvudkategorierna (15 px, 49 px hog, liten
    pil vid de som har underkategorier). Pekar man pa en kategori falls en
    bred panel ut under raden med underkategorierna (rubrik 22/500, lankar
    13 px). Menyraden byggs fran temats egen meny (samma lankar som i
    menyladan), sa den foljer menyn i Shopify automatiskt. Under 1280 px
    ar allt som forut (menyknappen). Utseendet: ns-finlir.css (an).
  */
  function bredHeader() {
    var header = document.querySelector('header.header');
    var topp = header ? header.querySelector('.header__top') : null;
    if (!topp || header.querySelector('.ns-wh')) return;
    var lis = [].slice.call(document.querySelectorAll('menu-drawer#MenuDrawer .menu-drawer__menus > ul > li'));
    if (!lis.length) return;
    var hit = location.pathname.replace(/\/$/, '');
    var rad = el('nav', 'ns-wh');
    rad.setAttribute('aria-label', 'Huvudmeny');
    var lista = el('ul', 'ns-wh__lista');
    var panel = el('div', 'ns-wh__panel');
    panel.hidden = true;
    var inre = el('div', 'ns-wh__inre');
    panel.appendChild(inre);
    var stangTimer = null;
    var aktivLi = null;
    function visaPanel(li, namn, barn) {
      clearTimeout(stangTimer);
      if (aktivLi === li && !panel.hidden) return;
      if (aktivLi) aktivLi.classList.remove('is-oppen');
      aktivLi = li;
      li.classList.add('is-oppen');
      inre.textContent = '';
      inre.appendChild(el('p', 'ns-wh__rubrik', namn));
      var ul = el('ul', 'ns-wh__barn');
      barn.forEach(function (b) {
        var bl = el('li');
        var a = el('a', '', /^Visa allt/i.test(b.t) ? 'Visa allt' : b.t);
        a.href = b.h;
        bl.appendChild(a);
        ul.appendChild(bl);
      });
      inre.appendChild(ul);
      panel.hidden = false;
    }
    function doljPanel(direkt) {
      clearTimeout(stangTimer);
      stangTimer = setTimeout(function () {
        panel.hidden = true;
        if (aktivLi) aktivLi.classList.remove('is-oppen');
        aktivLi = null;
      }, direkt ? 0 : 150);
    }
    lis.forEach(function (li) {
      var direkt = li.querySelector(':scope > a');
      var det = li.querySelector(':scope > details');
      var namn = '', href = '', barn = [];
      if (direkt) {
        namn = direkt.textContent.replace(/\s+/g, ' ').trim();
        href = direkt.getAttribute('href');
      } else if (det) {
        var sum = det.querySelector(':scope > summary');
        namn = sum ? sum.textContent.replace(/\s+/g, ' ').trim() : '';
        [].forEach.call(det.querySelectorAll(':scope > .menu-drawer__submenu > ul > li a[href]'), function (a) {
          barn.push({ t: a.textContent.replace(/\s+/g, ' ').trim(), h: a.getAttribute('href') });
        });
        var alla = barn.filter(function (b) { return /^Visa allt/i.test(b.t); })[0];
        href = alla ? alla.h : (barn[0] ? barn[0].h : '#');
      }
      if (!namn) return;
      var item = el('li', 'ns-wh__item' + (barn.length ? ' har-barn' : ''));
      var a = el('a', 'ns-wh__lank', namn);
      a.href = href;
      var traff = [href].concat(barn.map(function (b) { return b.h; })).some(function (h) { return h && h.replace(/\/$/, '') === hit; });
      if (traff && hit) item.classList.add('is-aktiv');
      if (barn.length) {
        a.setAttribute('aria-haspopup', 'true');
        a.appendChild(el('span', 'ns-wh__pil'));
        item.addEventListener('mouseenter', function () { visaPanel(item, namn, barn); });
        a.addEventListener('focus', function () { visaPanel(item, namn, barn); });
      } else {
        item.addEventListener('mouseenter', function () { doljPanel(true); });
        a.addEventListener('focus', function () { doljPanel(true); });
      }
      item.appendChild(a);
      lista.appendChild(item);
    });
    rad.appendChild(lista);
    rad.appendChild(panel);
    rad.addEventListener('mouseleave', function () { doljPanel(false); });
    panel.addEventListener('mouseenter', function () { clearTimeout(stangTimer); });
    rad.addEventListener('keydown', function (e) { if (e.key === 'Escape') doljPanel(true); });
    document.addEventListener('focusin', function (e) { if (!rad.contains(e.target)) doljPanel(true); });
    topp.parentNode.insertBefore(rad, topp.nextSibling);
    document.body.classList.add('ns-har-wh');
  }
  /* Omg 13: villkorssidorna (Shopifys policysidor). Mellanrubrikerna i
     policytexterna ar vanliga stycken ("1. Bestallning och avtal",
     "Angerratt" ...) och sag ut som brodtext. Korta stycken utan skiljetecken
     sist far klassen ns-pol-h och blir rubriker som hos Boozt (19.5 px,
     fet) - se ns-omg12.css (ax). Sjalva policytexten andras inte. */
  function villkorsRubriker() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;
    [].forEach.call(body.querySelectorAll('p'), function (p) {
      var t = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || t.length > 60 || /[.:!?,;]$/.test(t) || p.querySelector('a') || /^senast uppdaterad/i.test(t)) return;
      if (!p.nextElementSibling) return;
      p.classList.add('ns-pol-h');
    });
  }
  // FARG-VERSIONEN 2026-09-24: hogerRail() (spalten "Besokta/Favoriter" i
  // hogerkanten) anropas inte langre. Omgang 3: inte heller sidoListor() och
  // sidoVakt() ("Besokta produkter" och "Favoriter" i kategorisidans
  // vansterspalt). Lagg tillbaka anropen for att fa dem.
  function mobilStart() { underkatFlytta(); tillToppen(); filterText(); filterVakt(); prisVakt(); pdpExtra(); radKarusell(); bredHeader(); villkorsRubriker(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mobilStart);
  } else {
    mobilStart();
  }
  window.addEventListener('load', function () { bildPrickar(); setTimeout(bildPrickar, 800); });
})();
